import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'
import FieldView from '../../molecules/display/FieldView'
import Link from '../../atoms/navigation/Link'
import { ClientDetail } from '../../../types/Company'

type Props = {
  clientDetail: ClientDetail
}

export default function ClientBasicView({ clientDetail }: Props) {
  return (
    <FlexColumn>
      <FieldView label="企業ID">
        <Label text={clientDetail.uid} />
      </FieldView>
      {clientDetail.representativeName && (
        <FieldView label="代表者">
          <FlexRow>
            {clientDetail.representativeRole && <Label text={clientDetail.representativeRole ?? ''} />}
            <Label text={clientDetail.representativeName} />
          </FlexRow>
        </FieldView>
      )}
      {clientDetail.address && (
        <FieldView label="住所">
          <Label text={clientDetail.address} />
        </FieldView>
      )}
      {clientDetail.invoice_license_number && (
        <FieldView label="事業者登録番号">
          <Label text={clientDetail.invoice_license_number} />
        </FieldView>
      )}
      {clientDetail.fiscal_period && (
        <FieldView label="決算月">
          <Label text={`${clientDetail.fiscal_period}月末`} />
        </FieldView>
      )}
      {clientDetail.phoneNumber && (
        <FieldView label="電話番号（会社）">
          <Link href={`tel:${clientDetail.phoneNumber}`}>
            <Label text={clientDetail.phoneNumber} />
          </Link>
        </FieldView>
      )}
      {clientDetail.phoneNumberMobile && (
        <FieldView label="電話番号（携帯）">
          <Link href={`tel:${clientDetail.phoneNumberMobile}`}>
            <Label text={clientDetail.phoneNumberMobile} />
          </Link>
        </FieldView>
      )}
    </FlexColumn>
  )
}
